'use strict';

import { _, locale, format as $format, addMessages, init, getLocaleFromNavigator } from "svelte-i18n";
import { getProfile } from "./UserService.js";
import { getLiffLanguage } from "./LiffService.js";
import { getLanguageFromLocale } from "./Utils.js";

import '@formatjs/intl-pluralrules/polyfill';
import '@formatjs/intl-pluralrules/locale-data/en';
import '@formatjs/intl-pluralrules/locale-data/th';

import en from '../messages/en.json';
import th from '../messages/th.json';

addMessages('en', en);
addMessages('th', th);

// sync loading initial locale
var initialLocale;
if (typeof Storage !== "undefined") {
  initialLocale = localStorage.getItem("language");
}

if (!initialLocale) {
  initialLocale = getLocaleFromNavigator();
}

init({
  fallbackLocale: 'en',
  initialLocale: initialLocale
});

// async loading initial locale from languageSource
getProfile().then(function (profile) {
  let source = profile.languageSource;

  let languagePromise;
  switch (source) {
    case "line":
      languagePromise = getLiffLanguage().then(locale => getLanguageFromLocale(locale));
      break;
    case "custom":
      if (profile.language) {
        languagePromise = Promise.resolve(profile.language);
      } else {
        languagePromise = getLiffLanguage().then(locale => getLanguageFromLocale(locale));
      }
      break;
  }

  languagePromise.then(function (language) {
    if (!initialLocale.startsWith(language)) {
      if (typeof Storage !== "undefined") {
        localStorage.setItem("language", language);
      }

      if (!initialLocale.startsWith(language)) {
        locale.set(language);
      }
    }
  });
});

/**
 * Gets value from object considering the active locale.
 */
function lget(object, key, locale) {
  let language = getLanguageFromLocale(locale);
  let localeKey = key + "_" + language;
  let value = get(object, localeKey);
  return value || get(object, key);
}

function get(object, key) {
  if (typeof object.get === 'function') {
    return object.get(key);
  } else {
    return object[key];
  }
}

let format;
$format.subscribe(f => format = f);

export { _, locale, lget, getLocaleFromNavigator, format }